module.exports = __webpack_public_path__ + "static/august-2-3e6af1237cd569da547a7c13b9fc18fa.png";